var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyReturns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.004,
    height: 76.084,
    viewBox: "0 0 83.004 76.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my_returns",
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8451",
    "data-name": "Path 8451",
    d: "M71.167,35.036V18.023l8.3-8.3V38.2h2.767V6.383h-.012A1.346,1.346,0,0,0,80.85,5H14.45a1.377,1.377,0,0,0-.978.405L2.407,16.471A1.381,1.381,0,0,0,2,17.45V70.017A1.382,1.382,0,0,0,3.383,71.4h66.4a1.382,1.382,0,0,0,1.383-1.383V53.472A15.886,15.886,0,0,1,58.025,78.317a1.383,1.383,0,1,0,0,2.767h2.767A24.188,24.188,0,0,0,71.167,35.036Zm-1.956-18.97H44.073l8.3-8.3H77.511Zm-29.455.405a1.377,1.377,0,0,0-.4.978v9.683H33.817V18.023L44.073,7.767h4.388Zm-24.733-8.7H40.161l-8.3,8.3H6.723ZM4.767,68.633v-49.8H31.05v9.683A1.382,1.382,0,0,0,32.433,29.9h8.3a1.382,1.382,0,0,0,1.383-1.383V18.833H68.4V33.91a24.049,24.049,0,0,0-7.608-1.244H58.717V25.75a1.382,1.382,0,0,0-2.187-1.126L37.163,38.457a1.382,1.382,0,0,0,0,2.251L56.53,54.541a1.382,1.382,0,0,0,2.187-1.125v-6.9A15.839,15.839,0,0,1,68.4,50.36V68.633ZM71.233,75.6A18.666,18.666,0,0,0,58.025,43.733h-.692a1.382,1.382,0,0,0-1.383,1.383v5.612L40.35,39.582l15.6-11.146V34.05a1.382,1.382,0,0,0,1.383,1.383h3.458A21.439,21.439,0,0,1,71.233,75.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8452",
    "data-name": "Path 8452",
    d: "M6,47H18v2H6Z",
    transform: "translate(0 16.708)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8453",
    "data-name": "Path 8453",
    d: "M6,43H18v2H6Z",
    transform: "translate(0 15.116)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyReturns);
export default __webpack_public_path__ + "static/media/my_returns.8891a75d6c8d120c28aea5c35c631dbd.svg";
export { ForwardRef as ReactComponent };